import { FC } from "react";

import LocalImages from "../../../../../../assets/images/local-images";
import { SmallPrint } from "../../../../../shared/styles/typography/SmallPrint.styled";
import StyledCardError from "./styles/StyledCardError.styled";

interface CardErrorProps {
  message: string;
}

const CardError: FC<CardErrorProps> = ({ message }) => {
  const images = LocalImages.shared.images!;

  return (
    <StyledCardError>
      <img alt="card error message" src={images.icons.card.error} />
      <SmallPrint>{message}</SmallPrint>
    </StyledCardError>
  );
};

export default CardError;
